export default "__VITE_ASSET__0S1TJp7I__"